import AddItemCommand from "./AddItemCommand";
class ReomveCommand {
    constructor(id, env) {
        this.id = id;
        this.env = env;
        this.parmas = null;
        this.removedFlowers = [];
        this.containChange=true;
    }
    cloneData(value) {
        return JSON.parse(JSON.stringify(value || {}));
    }
    getFlowerRestoreParams(flowerObject) {
        const position = flowerObject.modelMesh && flowerObject.modelMesh.flowerMesh
            ? flowerObject.modelMesh.flowerMesh.position
            : null;
        return {
            id: flowerObject.id,
            resourceId: flowerObject.resource.id,
            position: position
                ? { x: position.x, y: position.y, z: position.z }
                : undefined,
            params: this.cloneData(flowerObject.params)
        };
    }
    do() {
        let containerObject = this.env.getContainerById
            ? this.env.getContainerById(this.id)
            : this.env.objects.container;
        if (containerObject && (containerObject.id === this.id)) {
            const isStudioMode = this.env.isStudioMode && this.env.isStudioMode();
            const boundFlowers = isStudioMode
                ? (this.env.getFlowersByContainerId
                    ? this.env.getFlowersByContainerId(containerObject.id)
                    : this.env.objects.flowers.filter(flowerObject => {
                        const params = flowerObject.params || {};
                        return params.containerId === containerObject.id
                            || params.groupId === containerObject.params.groupId;
                    }))
                : [];
            this.parmas = {
                id: this.id,
                resourceId: containerObject.resource.id,
                params: this.cloneData(containerObject.params),
                position: this.cloneData(containerObject.position),
                rotation: this.cloneData(containerObject.rotation)
            }
            this.removedFlowers = boundFlowers.map(flowerObject => this.getFlowerRestoreParams(flowerObject));
            boundFlowers.forEach(flowerObject => flowerObject.remove());
            containerObject.remove();
            if (this.env.refreshActiveContainer) {
                this.env.refreshActiveContainer();
            }
            if (this.env.listener['container-add']) {
                this.env.listener['container-add'](
                    this.env.objects.container && this.env.getContainerEventPayload
                        ? this.env.getContainerEventPayload(this.env.objects.container)
                        : null
                );
            }
            if (this.env.listener['studio-containers-change']) {
                this.env.listener['studio-containers-change'](this.env.getContainerLayers ? this.env.getContainerLayers() : []);
            }
            if (this.env.syncLayerState) {
                this.env.syncLayerState();
            }
        } else {
            for (let flowerObject of this.env.objects.flowers) {
                if (this.id === flowerObject.id) {
                    this.parmas = {
                        id: this.id,
                        resourceId: flowerObject.resource.id,
                        position: flowerObject.modelMesh.flowerMesh.position,
                        params: flowerObject.params
                    }
                    flowerObject.remove();
                    break;
                }
            }
        }
    }
    async prev() {
        if (!this.parmas) {
            return;
        }
        await new AddItemCommand(this.parmas, this.env).do();
        for (const flowerParams of this.removedFlowers) {
            await new AddItemCommand(flowerParams, this.env).do();
        }
        if (this.env.isStudioMode && this.env.isStudioMode() && this.env.selectContainerById) {
            this.env.selectContainerById(this.parmas.id);
        }
    }
}

export default ReomveCommand;
